import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import Head from 'next/head'
import Error from '@components/form/validation/Error'
import useT from '@hooks/useTranslation'

import styles from 'styles/Input.module.css'

const GOOGLE_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API
const PLACES_API_SRC = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&libraries=places`

export default function LocationSelect ({ defaultValue, name = 'lokalizacja', required }) {
    const { register, unregister, setValue } = useFormContext()
    const wymagane = useT('Wybierz lokalizację z listy')

    useEffect(() => {
        register(name, { required: required ? wymagane : undefined })
        initializeGooglePlacesAutocomplete(name, setValue)

        return () => {
            unregister(name)
            cleanupGooglePlacesAutocomplete(name)
        }
    }, [])

    useEffect(() => {
        if (defaultValue && Array.isArray(defaultValue)) {
            const input = document.getElementById(name)
            input.value = defaultValue[0]
            setValue(name, defaultValue)
        }
    }, [defaultValue])

    return <>
        <Head>
            <script key="spl-google-maps-places-sdk" src={PLACES_API_SRC} />
        </Head>
        <input className={`${styles.input} ${styles.action_input}`} id={name} name={name} />
        <Error name={name} />
    </>
}

// Google places autocomplete

const autocompleteOptions = {
    types: ['(cities)'],
    componentRestrictions: {
        country: ['pl', 'ua', 'gb', 'ge']
    }
}

let autocomplete
let changeListener
function initializeGooglePlacesAutocomplete (inputName, setValue) {
    if (typeof window === 'undefined') return
    function injectAutocomplete () {
        if (typeof window.google === 'undefined') return setTimeout(injectAutocomplete, 100)

        const input = document.getElementById(inputName)
        autocomplete = new window.google.maps.places.Autocomplete(input, autocompleteOptions)
        changeListener = window.google.maps.event.addListener(autocomplete, 'place_changed', () => {
            try {
                const place = autocomplete.getPlace()
                const { lat, lng } = place.geometry.location
                const essentials = [place.name, lng(), lat()]

                setValue(inputName, essentials)

            } catch (err) {
                input.focus()
            }
        })
    }

    injectAutocomplete()
}

function cleanupGooglePlacesAutocomplete () {
    if (typeof window === 'undefined') return null

    window.google.maps.event.removeListener(changeListener)
    window.google.maps.event.clearInstanceListeners(autocomplete)
    autocomplete = null
    changeListener = null
}